<div class="meal-content justi-moitu" *ngIf="moistureList.length > 0">
     <div class="meal-item moi-item">
        <label *ngFor="let moi of moistureList; let i= index" [ngClass]="{ 'attention': attentionFlgList[i] }" class="lbl">{{ moi }}</label>
    </div>
</div>  